export default __webpack_public_path__ + "static/media/Spinach.649ab2da.jpg";